export default __webpack_public_path__ + "static/media/rectangle_photo.a65ff032.png";